import { schema } from 'normalizr';

export const roundPnmSchema = new schema.Entity('roundPnm', {}, { idAttribute: 'id' });
export const roundPnmListSchema = [roundPnmSchema];
